import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Pagination from '@material-ui/lab/Pagination';

import { IoIosNotifications } from 'react-icons/io';
import GroupForm from './GroupForm';

import icoAdd from '../../assets/images/icons/ico-add.svg';
import icoEdit from '../../assets/images/icons/ico-edit.svg';
import icoTrash from '../../assets/images/icons/ico-trash.svg';
import CustomNotificationForm from '../CustomNotification/CustomNotificationForm';

import {
  GROUP_ADD_REQUEST,
  GROUP_UPDATE_REQUEST,
  GROUP_DELETE_REQUEST,
  GET_ALL_GROUPS_REQUEST,
  GET_ALL_ENTITYS_REQUEST,
  GET_ALL_MEMBERS_FOR_NOTIFICATION_REQUEST,
  CREATE_CUSTOM_NOTIFICATION,
} from '../../redux/actions/actionTypes';

import { capitalizeFirstLetter } from '../../utils/helpers';
import { ASSETS_BASE_URL } from '../../redux/env';

function Groups(props) {
  const {
    addGroup,
    updateGroup,
    deleteGroup,
    getAllGroups,
    getAllEntities,
    allEntities,
    allGroups,
    getAllMembersForNotification,
    allMembersForNotification,
    createCustomNotification,
  } = props;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [groupData, setGroupData] = useState();

  // Pagination
  const [activePage, setActivePage] = useState(1);
  const [pagesCount, setPagesCount] = useState(1);
  const [itemsPerPage] = useState(10);

  // Meditation Notification
  const [isDialogForMultipleUsersOpen, setIsDialogForMultipleUsersOpen] = useState(false);
  const [notificationData, setNotificationData] = useState();
  const [sendingMode, setSendingMode] = useState(2);

  useEffect(() => {
    if (allGroups) {
      setPagesCount(Math.ceil(allGroups.length / itemsPerPage));
    }
  }, [allGroups, itemsPerPage]);
  useEffect(() => {
    if (activePage > pagesCount) {
      setActivePage(1);
    }
  }, [pagesCount, activePage]);

  // Get Entities List
  useEffect(() => {
    getAllEntities();
  }, [getAllEntities]);

  const handlePageChange = (event, value) => {
    setActivePage(value);
  };

  // Get Groups List
  useEffect(() => {
    getAllGroups();
  }, [getAllGroups]);

  // Add/Update Group
  const openDialog = (data) => {
    // eslint-disable-next-line no-underscore-dangle
    if (data._id) {
      const finalObj = { ...data };
      if (data.entity) {
        // eslint-disable-next-line no-underscore-dangle
        finalObj.entity = finalObj.entity._id;
      }
      setGroupData(finalObj);
    }
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
    setGroupData(undefined);
  };

  const submit = (values) => {
    if (groupData) {
      const updatingData = groupData;
      // eslint-disable-next-line
      updatingData.id = groupData['_id'];
      // eslint-disable-next-line no-return-assign
      Object.keys(values).map((item) => (updatingData[item] = values[item]));
      updatingData.entityId = updatingData.entity;
      delete updatingData.entity;
      updateGroup(updatingData);
    } else {
      // eslint-disable-next-line no-param-reassign
      values.entityId = values.entity;
      // eslint-disable-next-line no-param-reassign
      delete values.entity;
      addGroup(values);
    }
    closeDialog();
  };

  // Delete Meditation
  const openDeleteDialog = (data) => {
    setGroupData(data);
    setIsDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
    setGroupData(undefined);
  };

  const confirmDelete = () => {
    // eslint-disable-next-line
    deleteGroup({ _id: groupData['_id'] });
    closeDeleteDialog();
  };

  useEffect(() => {
    const data = {
      name: null,
    };
    getAllMembersForNotification(data);
  }, [getAllMembersForNotification]);

  const openDialogForMultipleUsers = (data) => {
    console.log('[NOTIF_DEBUG allMembersForNotification]', allMembersForNotification);
    // if (data.title) {
    setNotificationData(data);
    // }
    setIsDialogForMultipleUsersOpen(true);
  };

  const closeDialogForMultipleUsers = () => {
    setIsDialogForMultipleUsersOpen(false);
    setNotificationData(undefined);
  };

  const submitNotificationForMultipleUsers = (values) => {
    console.log('[NOTIFICATION_IMAGE values]', values);
    let userIds = null;
    if (values.userIds && values.userIds.split(',').length > 0) {
      userIds = values.userIds.split(',');
    }
    const dataToSend = {
      // externalIds: userIds,
      // externalIds: ["5f38caa5c89bdc28ba532ffe"],
      title: values.title,
      body: values.body,
      notificationImage: values.notificationImage,
      notificationType: 'GROUP',
      notificationPayload: { _id: values._id },
    };
    if (sendingMode === 2) {
      dataToSend.externalIds = userIds;
    }
    console.log('[NOTIFICATION_IMAGE dataToSend]', dataToSend);
    createCustomNotification(dataToSend);
    closeDialogForMultipleUsers();
  };

  return (
    <div className="groups memberships members">
      <div className="page-title">
        <h1>Groups</h1>
      </div>
      <Paper className="paper">
        <Table stickyHeader className="table">
          <TableHead className="table-head">
            <TableRow>
              <TableCell className="th" />
              <TableCell className="th">
                <span>Group Name</span>
              </TableCell>
              <TableCell className="th">
                <span>Group Type</span>
              </TableCell>
              <TableCell className="th">
                <span>Entity</span>
              </TableCell>
              <TableCell className="th">
                <span>isFeatured</span>
              </TableCell>
              <TableCell className="th">
                <span>isPremium</span>
              </TableCell>
              <TableCell className="th">
                <span>Image</span>
              </TableCell>
              <TableCell className="th">
                <span>Actions</span>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="table-body">
            {allGroups
              .slice((activePage - 1) * itemsPerPage, activePage * itemsPerPage)
              .map((row, index) => (
                <TableRow key={row.name}>
                  <TableCell className="cell" style={{ textAlign: 'center' }}>
                    <span># {index + 1}</span>
                  </TableCell>
                  <TableCell className="cell">
                    <span>{row.name}</span>
                  </TableCell>
                  <TableCell className="cell">
                    <span>{capitalizeFirstLetter(row.type)}</span>
                  </TableCell>
                  <TableCell className="cell">
                    <span>
                      {row?.entity?.firstName} {row?.entity?.lastName}
                    </span>
                  </TableCell>
                  <TableCell className="cell">
                    <span>{row.isFeatured ? 'Yes' : 'No'}</span>
                  </TableCell>
                  <TableCell className="cell">
                    <span>{row.isPremium ? 'Yes' : 'No'}</span>
                  </TableCell>
                  <TableCell className="cell">
                    <img
                      alt="animation"
                      src={`${ASSETS_BASE_URL}/${row.image}`}
                      className="thumbnail"
                    />
                  </TableCell>
                  <TableCell className="cell">
                    <div className="head-cell cell-actions">
                      <div className="action-icons">
                        <div
                          className="action-icon"
                          role="presentation"
                          onClick={() => openDialog(row)}
                        >
                          <img src={icoEdit} alt="" className="edit-ico" />
                        </div>
                        <div
                          className="action-icon"
                          role="presentation"
                          onClick={() => openDeleteDialog(row)}
                        >
                          <img src={icoTrash} alt="" className="edit-ico" />
                        </div>
                        <div
                          className="action-icon"
                          role="presentation"
                          onClick={() => openDialogForMultipleUsers(row)}
                        >
                          <IoIosNotifications size={23} color="#00264e" />
                        </div>
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <div className="add-ico" role="presentation" onClick={openDialog}>
          <img src={icoAdd} alt="" />
        </div>
      </Paper>

      {pagesCount !== 1 ? (
        <div className="pagination-wrapper">
          <Pagination count={pagesCount} page={activePage} onChange={handlePageChange} />
        </div>
      ) : null}

      <Dialog open={isDialogOpen} onClose={closeDialog} className="groups-dialog">
        <DialogTitle>{groupData ? 'Update Group' : 'Add Group'}</DialogTitle>
        <DialogContent>
          <GroupForm
            allEntities={allEntities}
            initialValues={groupData}
            closeDialog={closeDialog}
            onSubmit={submit}
          />
        </DialogContent>
      </Dialog>

      <Dialog open={isDeleteDialogOpen} onClose={closeDeleteDialog} className="groups-dialog">
        <DialogTitle>Delete Group</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this Group?</p>
          <div className="text-center customForm">
            <button
              type="button"
              onClick={closeDeleteDialog}
              className="submit-button cancel-button"
            >
              No
            </button>
            <button type="button" className="submit-button" onClick={confirmDelete}>
              Yes
            </button>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={isDialogForMultipleUsersOpen}
        onClose={closeDialogForMultipleUsers}
        className="notifications-dialog"
      >
        <DialogTitle>Send Notification To Multiple Users</DialogTitle>
        <DialogContent>
          <CustomNotificationForm
            initialValues={notificationData}
            closeDialog={closeDialogForMultipleUsers}
            onSubmit={submitNotificationForMultipleUsers}
            allMembersForNotification={allMembersForNotification}
            getAllMembersForNotification={getAllMembersForNotification}
            notificationType="GROUP"
            sendingMode={sendingMode}
            setSendingMode={setSendingMode}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}

Groups.propTypes = {
  addGroup: PropTypes.func,
  updateGroup: PropTypes.func,
  deleteGroup: PropTypes.func,
  getAllGroups: PropTypes.func,
  getAllEntities: PropTypes.func,
  allEntities: PropTypes.arrayOf(PropTypes.shape({})),
  allGroups: PropTypes.arrayOf(PropTypes.shape({})),
  getAllMembersForNotification: PropTypes.func,
  allMembersForNotification: PropTypes.arrayOf(PropTypes.shape({})),
  createCustomNotification: PropTypes.func,
};

Groups.defaultProps = {
  addGroup: undefined,
  updateGroup: undefined,
  deleteGroup: undefined,
  getAllGroups: undefined,
  getAllEntities: undefined,
  allEntities: undefined,
  allGroups: undefined,
  getAllMembersForNotification: undefined,
  allMembersForNotification: undefined,
  createCustomNotification: undefined,
};

const mapStateToProps = (state) => ({
  loading: state.loading,
  allEntities: state.allEntities,
  allGroups: state.allGroups,
  allMembersForNotification: state.allMembersForNotification,
});

const actionsStateToProps = {
  addGroup: (data) => ({ type: GROUP_ADD_REQUEST, data }),
  updateGroup: (data) => ({ type: GROUP_UPDATE_REQUEST, data }),
  deleteGroup: (data) => ({ type: GROUP_DELETE_REQUEST, data }),
  getAllEntities: () => ({ type: GET_ALL_ENTITYS_REQUEST }),
  getAllGroups: () => ({ type: GET_ALL_GROUPS_REQUEST }),
  getAllMembersForNotification: (data) => ({
    type: GET_ALL_MEMBERS_FOR_NOTIFICATION_REQUEST,
    data,
  }),
  createCustomNotification: (data) => ({ type: CREATE_CUSTOM_NOTIFICATION, data }),
};

export default connect(mapStateToProps, actionsStateToProps)(Groups);
